import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** Admin navigation menu option to Release Lock. User must have flag nav-admin = true for visibility. */
export const useFlagadminReleaseLock = (): boolean => useINTERNALFlag('admin-release-lock');
/** Admin navigation menu option to Release Lock. User must have flag nav-admin = true for visibility. */
export const FlagadminReleaseLock = (props: PropsNoName) => <INTERNALFlag name="admin-release-lock" {...props}/>
